// src/api/modelService.js
import apiClient from './axiosConfig';

const API_URL = process.env.REACT_APP_API_URL || '';

const handleApiError = (error, operation) => {
  console.error(`${error.config?.method?.toUpperCase()} ${error.config?.url} - Error ${operation}:`, error);
  let message = 'An unknown error occurred.';
  const status = error.response?.status;

  if (error.response?.data) {
    const d = error.response.data;
    if (typeof d.detail === 'string') {
        message = d.detail;
    } else if (Array.isArray(d.detail)) {
        message = d.detail.map(err => {
            const loc = err.loc?.slice(1).join('.') || 'field';
            return `${loc}: ${err.msg}`;
        }).join('; ');
         if (!message) message = "Validation error";
    } else if (typeof d === 'string' && d.length < 500) {
        message = d;
    } else if (d.message && typeof d.message === 'string') {
        message = d.message;
    } else if (status) {
         message = `Request failed with status code ${status}`;
    }
     if (typeof message === 'string' && message.trim().startsWith('<')) {
         message = `Request failed with status code ${status || 'unknown'}`;
     }
  } else if (error.message) {
    message = error.message;
  }

  return {
    isError: true,
    message,
    status: status,
    originalError: error
  };
};

export const modelService = {
  /**
   * PUT /api/v1/agents/{agent_id} (partially, to update llm_model)
   * Updates the LLM model for a specific agent.
   */
  updateModel: async (agentId, llmModel) => {
    try {
      const payload = { llm_model: llmModel };
      const { data } = await apiClient.put(
        `${API_URL}/api/v1/agents/${agentId}`, // Endpoint targets agent update
        payload
      );
      return data; // AgentResponse
    } catch (err) {
      return handleApiError(err, `updating model for agent ${agentId}`);
    }
  },

  /**
   * GET /api/v1/llm/available
   * Fetches the list of available LLM models from the backend.
   * @returns {Promise<object|{isError: boolean, message: string}>} - The raw model data object from the provider or an error object.
   */
  getAvailableModels: async () => {
    try {
      const { data } = await apiClient.get(`${API_URL}/api/v1/llm/available`);
      if (!data) {
        // This path might not be hit if axios throws for non-2xx or empty responses depending on config
        throw new Error("No data received from available models endpoint.");
      }
      if (data && typeof data === 'object' && data.error) {
         console.error("Backend indicated an error fetching models:", data.error);
         return handleApiError({ response: { data: { detail: data.error.message || String(data.error) } } }, 'fetching available models (provider error)');
      }
      return data;
    } catch (err) {
      return handleApiError(err, 'fetching available LLM models');
    }
  },

  // Admin-related functions getCurrentModel and reinitializeAgent have been removed.
};